import { createSelector } from '@reduxjs/toolkit';
import { EPromoType, IPromoState } from 'reactApp/modules/promo/promo.types';
import { RootState } from 'reactApp/store';

const getPromoRoot = (state: RootState) => state.promo as IPromoState;

export const getPromoQueue = createSelector(getPromoRoot, (state) => [...state.queue]);
export const getCurrentPromo = createSelector(getPromoRoot, (state) => state.currentPromo);
export const getLastPromoShowTime = createSelector(getPromoRoot, (state) => state.lastPromoShownTimestamp);
export const getWhatsNew = createSelector(getPromoRoot, (state) =>
    state.currentPromo?.type === EPromoType.whatsNew ? state.currentPromo : null
);
export const getTopBanner = createSelector(getPromoRoot, (state) =>
    state.currentPromo?.type === EPromoType.topBanner ? state.currentPromo : null
);

export const PromoSelectors = {
    getPromoQueue,
    getCurrentPromo,
    getLastPromoShowTime,
    getTopBanner,
    getWhatsNew,
};
